module.exports = __webpack_public_path__ + "static/priviliges-7-2073d5a8551e2e63adab445330c071a4.png";